import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import Feature from '../../Feature';

export default function FeaturesSection({ sectionTitle, data }) {
  return (
    <div className='cs_shape_wrap'>
      <div className='cs_shape_1' />
      <div className='container'>
        <SectionHeading title={sectionTitle} center />
        <Spacing md='72' lg='50' />
        <div className='cs_random_features' style={{ alignItems: 'stretch' }}>
          {data?.map((item, index) => (
            <div
              className='cs_random_features_col d-flex mb-5'
              style={{ paddingTop: 0 }}
              key={index}
            >
              <Feature {...item} />
            </div>
          ))}
        </div>
        <Spacing md='100' lg='80' />
      </div>
    </div>
  );
}
